var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1862_1197)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1862_1197",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1862_1197)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1862_1197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3366 12.3466L14.0766 11.9195C13.9083 12.022 13.8159 12.2137 13.8406 12.4092C13.8652 12.6046 14.0023 12.7674 14.1908 12.8249L14.3366 12.3466ZM9.66345 12.3466L9.80928 12.8249C9.99774 12.7674 10.1349 12.6046 10.1596 12.4092C10.1842 12.2137 10.0918 12.022 9.92344 11.9195L9.66345 12.3466ZM16.0001 8.5C16.0001 9.94799 15.231 11.2168 14.0766 11.9195L14.5966 12.7737C16.0366 11.8971 17.0001 10.3113 17.0001 8.5H16.0001ZM12.0001 4.5C14.2092 4.5 16.0001 6.29086 16.0001 8.5H17.0001C17.0001 5.73858 14.7615 3.5 12.0001 3.5V4.5ZM8.00001 8.5C8.00001 6.29086 9.79087 4.5 12.0001 4.5V3.5C9.23859 3.5 7.00001 5.73858 7.00001 8.5H8.00001ZM9.92344 11.9195C8.76909 11.2168 8.00001 9.948 8.00001 8.5H7.00001C7.00001 10.3113 7.96347 11.8971 9.40347 12.7737L9.92344 11.9195ZM9.51763 11.8683C6.36088 12.8309 3.98361 15.5804 3.56549 18.9402L4.55783 19.0637C4.92643 16.1018 7.02386 13.6742 9.80928 12.8249L9.51763 11.8683ZM3.56549 18.9402C3.45498 19.8282 4.1906 20.5 5.00001 20.5V19.5C4.70486 19.5 4.53193 19.2719 4.55783 19.0637L3.56549 18.9402ZM5.00001 20.5H19.0001V19.5H5.00001V20.5ZM19.0001 20.5C19.8095 20.5 20.5451 19.8282 20.4346 18.9402L19.4422 19.0637C19.4681 19.2719 19.2952 19.5 19.0001 19.5V20.5ZM20.4346 18.9402C20.0165 15.5804 17.6392 12.8309 14.4824 11.8683L14.1908 12.8249C16.9762 13.6742 19.0736 16.1018 19.4422 19.0637L20.4346 18.9402Z",
    fill: "#989898"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1862_1197",
    x: 1.05444,
    y: 3.5,
    width: 21.8911,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1862_1197"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1862_1197",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1862_1197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.327abde0a940f987264dfcdb37eb443c.svg";
export { ForwardRef as ReactComponent };